import { SafetyOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useIntl } from 'react-intl'
import { ActionButton } from 'shared/ui'
import { Reset3dsDrawer } from './Reset3dsDrawer';

export const Reset3dsButton = () => {
  const { formatMessage: t } = useIntl();
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
  }

  return (
    <>
      <ActionButton
        text={t({ id: 'card.3ds.reset' })}
        icon={<SafetyOutlined />}
        onClick={() => setOpen(true)}
      />
      <Reset3dsDrawer open={open} onClose={onClose} />
    </>
  )
}